export const environment = {
  name: 'Magicbook',
  production: false,
  staging: false,
  countries: ['US', 'GB'],
  API: 'https://api.dev.magicbook.io/v1',
  editAlbumBaseUrl: 'https://zulu.dev.magicbook.io/',
  gtmId: '',
  pixelId: '2733209213588157',
  socalLogins: true,
  facebookAppId: '2330854210373807',
  googleLoginProviderUri: '503287685466-q6ecsn6nl71t6dr94gga997tal7lhcr1.apps.googleusercontent.com',
  appleClientId: 'com.gomagicbook.dev.web',
  privacyPolicyLink: 'https://www.phototales.com/privacy/',
  termsOfUseLink: 'https://www.phototales.com/legal/',
  landingEnabled: false,
  iOSAppLink:
    'https://apps.apple.com/us/app/magicbook-beautiful-photobook/id1435916885?ls=1',
  androidAppLink:
    'https://play.google.com/store/apps/details?id=com.gomagicbook.app',
  guestViewAlbumActionsVisible: true,
  firebaseConfig: {
    apiKey: 'AIzaSyDQ7-IXoMW4vKpXk_6qAbxaLNnUiAw-J8Y',
    authDomain: 'magicbook-dev-e3806.firebaseapp.com',
    databaseURL: 'https://magicbook-dev-e3806.firebaseio.com',
    projectId: 'magicbook-dev-e3806',
    storageBucket: 'magicbook-dev-e3806.appspot.com',
    messagingSenderId: '503287685466',
    appId: '1:503287685466:web:3de5818afaae9735e61363',
    measurementId: 'G-ECN22D5NJJ'
  },
  logging: {
    analytics: false,
    storyShowing: false,
    storyCreating: false,
  },
};
